const colors = {
  solid: {
    '0': '#ffffff',
    '25': '#f6f8fa',
    '50': '#ECEFF3',
    '100': '#DFE1E6',
    '200': '#C1C7CF',
    '300': '#A4ABB8',
    '400': '#808897',
    '500': '#666D80',
    '600': '#353849',
    '700': '#272835',
    '800': '#1A1B25',
    '900': '#0D0D12',
  },

  alpha: {
    '0': '#165778',
    '25': '#1D4F80',
    '50': '#113668',
    '100': '#091948',
    '200': '#072045',
    '300': '#01163B',
    '400': '#021030',
    '500': '#000B28',
    '600': '#000318',
    '700': '#010213',
    '800': '#01020E',
    '900': '#000005',
  },

  neutral: {
    '400': '#838B93'
  },

  background: {
    White: '#FFFFFF',
    wrapper: '#F7F8FA',
    'Disabled[0]': '#F8F9FB',
    'Nornaml[25]': '#F6F8FA',
    'Hover[50]': '#ECEFF3',
    'Pressed[100]': '#DFE1E6',
    'Loud[900]': '#0D0D12',
  },

  border: {
    White: '#FFFFFF',
    'Disabled[25]': '#F6F8FA',
    'Normal[50]': '#ECEFF3',
    'Hover[100]': '#DFE1E6',
    'Pressed[200]': '#C1C7CF',
  },

  icon: {
    White: '#FFFFFF',
    'Disabled[300]': '#a4acb9',
    'Subdued[400]': '#818898',
    'Normal[500]': '#666D80',
    'Muted[600]': '#36394a',
    'Loud[900]': '#0D0D12',
  },

  text: {
    White: '#FFFFFF',
    'Disabled[300]': '#a4acb9',
    'Subdued[400]': '#818898',
    'Normal[500]': '#666D80',
    'Muted[600]': '#36394a',
    'Loud[900]': '#0D0D12',
  },

  primary: {
    '0': '#efeffa',
    '25': '#dfdff5',
    '50': '#7d7ed5',
    '100': '#5d5ecb',
    '200': '#4a4ba2',
    '300': '#38387a',
    '400': '#252651',
    '500': '#131329',
  },

  blue: {
    '10': '#EBEFFD',
    '50': '#C7D2F9',
    '100': '#2049DE',
  },
  pink: {
    '10': '#FFEFF6',
    '50': '#FED3E5',
    '100': '#FB61A2',
  },

  aqua: {
    '0': '#f0fbff',
    '25': '#d1f0fa',
    '50': '#7eddf1',
    '100': '#33CFFF',
    '200': '#116b97',
    '300': '#0c4e6e',
  },

  warning: {
    '0': '#FFF6E0',
    '25': '#faedcc',
    '50': '#fcda83',
    '100': '#ffbe4c',
    '200': '#cc983d',
    '300': '#99722e',
    '400': '#664c1e',
    '500': '#33260f',
  },
  success: {
    '0': '#effefa',
    '25': '#ddf3ef',
    '50': '#9ee1d4',
    '100': '#40C4AA',
    '200': '#339d88',
    '300': '#267666',
    '400': '#1a4e44',
    '500': '#0d2722',
  },
  error: {
    '0': '#fff0f3',
    '25': '#fadbe1',
    '50': '#ed8296',
    '100': '#df1c41',
    '200': '#b21634',
    '300': '#861127',
    '400': '#590b1a',
    '500': '#2d060d',
  },
}

export { colors }
